<template>
  <div>
    <v-table
      :height="550"
      @on-custom-comp="customCompFuncAddTask"
      is-horizontal-resize=""
      column-width-drag
      style="width:100%;"
      :columns="columns1"
      :table-data="serverSearchsDate"
      row-hover-color="#edf7ff"
      :is-loading="modal_loading"
      title-bg-color="#f8f8f9"
    ></v-table>
    <br />
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <!-- 提醒已有定时任务模式框 -->
    <Modal
      v-model="remindThereAreScheduledTasksModel"
      width="420"
      :mask-closable="false"
    >
      <p slot="header" style="color:#ff6600;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>已存在定时开关机任务提醒</span>
      </p>
      <div style="text-align:center">
        <p>已存在定时开关机任务,继续创建新的定时开关机任务吗?</p>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="addTaskCancel()">
          取消
        </Button>
        <Button type="primary" :loading="loading" @click="addTask()">
          继续
        </Button>
      </div>
    </Modal>
    <!-- 添加定时任务 -->
    <Modal
      v-model="addTimerSwitchModal"
      :title="$t('schedule_instance_config.addSystemTask')"
      @on-ok="timerSwitchSubmit('timerSwitchForm')"
      @on-cancel="timerSwitchReset('timerSwitchForm')"
      :loading="addLoading"
      :mask-closable="false"
      width="700px;"
      :okText="$t('alarms.common.add')"
      :cancelText="$t('alarms.common.cancel')"
      :styles="{ top: '35px' }"
    >
      <Form
        ref="timerSwitchForm"
        :model="timerSwitchForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <Row>
          <Col span="11">
            <!-- 状态 -->
            <FormItem
              :label="$t('schedule_instance_config.status')"
              prop="state"
            >
              <Select v-model="timerSwitchForm.state" style="width:200px;">
                <Option
                  :value="item.state"
                  v-for="item in statusLists"
                  v-bind:key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="11">
            <!-- 审批流 -->
            <FormItem
              :label="$t('schedule_instance_config.approvalFlow')"
              prop="approvalFlow"
            >
              <Select
                v-model="timerSwitchForm.approvalFlow"
                style="width:200px;"
                placeholder=""
              >
                <Option
                  :value="item.id"
                  v-for="(item, index) in approvalFlowList"
                  v-bind:key="index"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <!-- 是否例外 -->
            <FormItem
              :label="$t('schedule_instance_config.isException')"
              prop="exception"
            >
              <RadioGroup v-model="timerSwitchForm.exception">
                <Radio
                  v-for="list in exceptionList"
                  :label="list.exception"
                  :key="list.value"
                  >{{ list.label }}</Radio
                >
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="11">
            <!-- 是否工作日 -->
            <FormItem
              :label="$t('schedule_instance_config.isWorkDay')"
              prop="isWorkDay"
            >
              <RadioGroup v-model="timerSwitchForm.isWorkDay">
                <Radio
                  v-for="list in workDayList"
                  :label="list.isWorkDay"
                  :key="list.value"
                  >{{ list.label }}</Radio
                >
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <!-- 执行类型 -->
            <FormItem
              :label="$t('schedule_instance_config.performType')"
              prop="performType"
            >
              <Select
                v-model="timerSwitchForm.performType"
                style="width:200px;"
                placeholder=""
                @on-change="changePerformType"
              >
                <Option
                  :value="item.id"
                  v-for="(item, index) in performTypeList"
                  v-bind:key="index"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <div v-if="timerSwitchForm.performType == 0">
            <Col span="11">
              <!-- 开机时间 -->
              <FormItem
                :label="$t('schedule_instance_config.scheduleOpenInstanceTime')"
                prop="scheduleStartTime"
              >
                <TimePicker
                  v-model="timerSwitchForm.scheduleStartTime"
                  :disabled-seconds="[
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59
                  ]"
                  style="width: 200px"
                ></TimePicker>
              </FormItem>
            </Col>
            <Col span="11">
              <!-- 关机时间 -->
              <FormItem
                :label="
                  $t('schedule_instance_config.scheduleCloseInstanceTime')
                "
                prop="scheduleEndTime"
              >
                <TimePicker
                  v-model="timerSwitchForm.scheduleEndTime"
                  :disabled-seconds="[
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59
                  ]"
                  style="width: 200px"
                ></TimePicker>
              </FormItem>
            </Col>
          </div>
          <div v-else-if="timerSwitchForm.performType == 1">
            <Col span="11">
              <!-- 开机时间 -->
              <FormItem
                :label="$t('schedule_instance_config.scheduleOpenInstanceTime')"
                prop="scheduleStartTime"
              >
                <TimePicker
                  v-model="timerSwitchForm.scheduleStartTime"
                  :disabled-seconds="[
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59
                  ]"
                  style="width: 200px"
                ></TimePicker>
              </FormItem>
            </Col>
            <Col span="11">
              <!-- 关机时间 -->
              <FormItem
                :label="
                  $t('schedule_instance_config.scheduleCloseInstanceTime')
                "
                prop="scheduleEndTime"
              >
                <TimePicker
                  v-model="timerSwitchForm.scheduleEndTime"
                  disabled
                  style="width: 200px"
                ></TimePicker>
              </FormItem>
            </Col>
          </div>
          <div v-else-if="timerSwitchForm.performType == 2">
            <!-- 当执行关机时 -->
            <Col span="11">
              <!-- 开机时间 -->
              <FormItem
                :label="$t('schedule_instance_config.scheduleOpenInstanceTime')"
                prop="scheduleStartTime"
              >
                <TimePicker
                  v-model="timerSwitchForm.scheduleStartTime"
                  disabled
                  style="width: 200px"
                ></TimePicker>
              </FormItem>
            </Col>
            <Col span="11">
              <!-- 关机时间 -->
              <FormItem
                :label="
                  $t('schedule_instance_config.scheduleCloseInstanceTime')
                "
                prop="scheduleEndTime"
              >
                <TimePicker
                  v-model="timerSwitchForm.scheduleEndTime"
                  :disabled-seconds="[
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59
                  ]"
                  style="width: 200px"
                ></TimePicker>
              </FormItem>
            </Col>
          </div>
        </Row>
        <div v-if="timerSwitchForm.exception == 'true'">
          <Row>
            <Col span="11">
              <!-- 例外开始日期 -->
              <FormItem
                :label="$t('schedule_instance_config.exceptionStartDate')"
                prop="exceptionStartDate"
              >
                <DatePicker
                  type="datetime"
                  style="width: 200px"
                  v-model="timerSwitchForm.exceptionStartDate"
                  :options="editStartTimeOptions"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="11">
              <!-- 例外结束日期 -->
              <FormItem
                :label="$t('schedule_instance_config.exceptionEndDate')"
                prop="exceptionEndDate"
              >
                <DatePicker
                  type="datetime"
                  style="width: 200px"
                  v-model="timerSwitchForm.exceptionEndDate"
                  :options="editEndTimeOptions"
                ></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <div v-if="timerSwitchForm.performType == 0">
              <Col span="11">
                <!-- 例外开机时间 -->
                <FormItem
                  :label="$t('schedule_instance_config.exceptionStartTime')"
                  prop="exceptionStartTime"
                >
                  <TimePicker
                    v-model="timerSwitchForm.exceptionStartTime"
                    :disabled-seconds="[
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49,
                      50,
                      51,
                      52,
                      53,
                      54,
                      55,
                      56,
                      57,
                      58,
                      59
                    ]"
                    style="width: 200px"
                  ></TimePicker>
                </FormItem>
              </Col>
              <Col span="11">
                <!-- 例外关机时间 -->
                <FormItem
                  :label="$t('schedule_instance_config.exceptionEndTime')"
                  prop="exceptionEndTime"
                >
                  <TimePicker
                    v-model="timerSwitchForm.exceptionEndTime"
                    :disabled-seconds="[
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49,
                      50,
                      51,
                      52,
                      53,
                      54,
                      55,
                      56,
                      57,
                      58,
                      59
                    ]"
                    style="width: 200px"
                  ></TimePicker>
                </FormItem>
              </Col>
            </div>
            <div v-else-if="timerSwitchForm.performType == 1">
              <Col span="11">
                <!-- 例外开机时间 -->
                <FormItem
                  :label="$t('schedule_instance_config.exceptionStartTime')"
                  prop="exceptionStartTime"
                >
                  <TimePicker
                    v-model="timerSwitchForm.exceptionStartTime"
                    :disabled-seconds="[
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49,
                      50,
                      51,
                      52,
                      53,
                      54,
                      55,
                      56,
                      57,
                      58,
                      59
                    ]"
                    style="width: 200px"
                  ></TimePicker>
                </FormItem>
              </Col>
              <Col span="11">
                <!-- 例外关机时间 -->
                <FormItem
                  :label="$t('schedule_instance_config.exceptionEndTime')"
                  prop="exceptionEndTime"
                >
                  <TimePicker
                    v-model="timerSwitchForm.exceptionEndTime"
                    disabled
                    style="width: 200px"
                  ></TimePicker>
                </FormItem>
              </Col>
            </div>
            <div v-else-if="timerSwitchForm.performType == 2">
              <!-- 当执行关机时 -->
              <Col span="11">
                <!-- 例外开机时间 -->
                <FormItem
                  :label="$t('schedule_instance_config.exceptionStartTime')"
                  prop="exceptionStartTime"
                >
                  <TimePicker
                    v-model="timerSwitchForm.exceptionStartTime"
                    disabled
                    style="width: 200px"
                  ></TimePicker>
                </FormItem>
              </Col>
              <Col span="11">
                <!-- 例外关机时间 -->
                <FormItem
                  :label="$t('schedule_instance_config.exceptionEndTime')"
                  prop="exceptionEndTime"
                >
                  <TimePicker
                    v-model="timerSwitchForm.exceptionEndTime"
                    :disabled-seconds="[
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      24,
                      25,
                      26,
                      27,
                      28,
                      29,
                      30,
                      31,
                      32,
                      33,
                      34,
                      35,
                      36,
                      37,
                      38,
                      39,
                      40,
                      41,
                      42,
                      43,
                      44,
                      45,
                      46,
                      47,
                      48,
                      49,
                      50,
                      51,
                      52,
                      53,
                      54,
                      55,
                      56,
                      57,
                      58,
                      59
                    ]"
                    style="width: 200px"
                  ></TimePicker>
                </FormItem>
              </Col>
            </div>
          </Row>
        </div>
        <!-- 实例 -->
        <FormItem
          :label="$t('schedule_instance_config.instance')"
          prop="instance"
        >
          <Table
            :no-data-text="$t('common.noData')"
            :columns="columns4"
            :data="InstancesData"
            :height="200"
            style="width:510px;"
          ></Table>
        </FormItem>
        <!-- 描述 -->
        <FormItem
          :label="$t('schedule_instance_config.reason')"
          prop="describe"
        >
          <Input
            v-model="timerSwitchForm.describe"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder=""
            style="width:510px;"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Vue from "vue";
import utils from "../../../utils/utils.js";

var tableServerSearchs = {};
export default {
  name: "TableServerSearchs",
  data() {
    const validatePassStart = (rule, value, callback) => {
      if (
        this.timerSwitchForm.performType == 0 ||
        this.timerSwitchForm.performType == 1
      ) {
        if (
          this.timerSwitchForm.scheduleStartTime == "" ||
          this.timerSwitchForm.scheduleStartTime == undefined
        ) {
          callback(new Error("开机必填!"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const validatePassEnd = (rule, value, callback) => {
      if (
        this.timerSwitchForm.performType == 0 ||
        this.timerSwitchForm.performType == 2
      ) {
        if (
          this.timerSwitchForm.scheduleEndTime == "" ||
          this.timerSwitchForm.scheduleEndTime == undefined
        ) {
          callback(new Error("关机必填!"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const validatePassExceptionStart = (rule, value, callback) => {
      if (
        this.timerSwitchForm.performType == 0 ||
        this.timerSwitchForm.performType == 1
      ) {
        if (
          this.timerSwitchForm.exceptionStartTime == "" ||
          this.timerSwitchForm.exceptionStartTime == undefined
        ) {
          callback(new Error("例外开机必填!"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const validatePassExceptionEnd = (rule, value, callback) => {
      if (
        this.timerSwitchForm.performType == 0 ||
        this.timerSwitchForm.performType == 2
      ) {
        if (
          this.timerSwitchForm.exceptionEndTime == "" ||
          this.timerSwitchForm.exceptionEndTime == undefined
        ) {
          callback(new Error("例外关机必填!"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      performTypeList: [],
      val: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      status: "",
      editTimeTaskModal: false,
      loadingEdit: true,
      isExceptions: false,
      isFinished: true,
      workDayEditList: [
        {
          label: this.$t("schedule_instance_config.workDay"),
          value: "true",
          isWorkDay: "true"
        },
        {
          label: this.$t("schedule_instance_config.everyDay"),
          value: "false",
          isWorkDay: "false"
        }
      ],
      exceptionList: [
        {
          //添加定时任务
          label: this.$t("schedule_instance_config.yes"),
          value: "true",
          exception: "true"
        },
        {
          label: this.$t("schedule_instance_config.no"),
          value: "false",
          exception: "false"
        }
      ],
      workDayList: [
        {
          label: this.$t("schedule_instance_config.workDay"),
          value: "true",
          isWorkDay: "true"
        },
        {
          label: this.$t("schedule_instance_config.everyDay"),
          value: "false",
          isWorkDay: "false"
        }
      ],
      timerSwitchForm: {
        state: "0",
        scheduleStartTime: "00:00:00",
        scheduleEndTime: "00:00:00",
        exceptionStartTime: "00:00:00",
        exceptionEndTime: "00:00:00",
        exceptionStartDate: "",
        exceptionEndDate: "",
        exception: "false",
        describe: "",
        isWorkDay: "true",
        approvalFlow: "",
        performType: 0
      },
      statusLists: [
        {
          id: 1,
          name: this.$t("schedule_instance_config.start"),
          state: "0"
        }
      ],
      approvalFlowList: [],
      startTimeOptions: {}, //开始日期设置
      endTimeOptions: {}, //结束日期设置
      addTimerSwitchModal: false,
      remindThereAreScheduledTasksModel: false,
      addLoading: true,
      privateIp: "",
      awsResourceType: "",
      companyId: "",
      reachBottomParam: "",
      exportDataList: "",
      accountsDelmodal: false,
      modal_loading: false,
      loading: false,
      isDisable: false,
      statusList: [
        "pending",
        "running",
        "stopping",
        "stopped",
        "shutting down",
        "terminated"
      ],
      ruleValidate: {
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
        performType: [
          {
            required: true,
            message: "请选择执行类型",
            trigger: "change",
            type: "number"
          }
        ],
        scheduleStartTime: [
          { required: false, message: "请选择开机时间", trigger: "blur" },
          { validator: validatePassStart, trigger: "blur" }
        ],
        scheduleEndTime: [
          { required: false, message: "请选择关机时间", trigger: "blur" },
          { validator: validatePassEnd, trigger: "blur" }
        ],
        exceptionStartTime: [
          { required: false, message: "请选择例外开机时间", trigger: "blur" },
          { validator: validatePassExceptionStart, trigger: "blur" }
        ],
        exceptionEndTime: [
          { required: false, message: "请选择例外关机时间", trigger: "blur" },
          { validator: validatePassExceptionEnd, trigger: "blur" }
        ],
        exceptionStartDate: [
          {
            required: true,
            message: "请选择例外开始日期",
            trigger: "blur",
            type: "date"
          }
        ],
        approvalFlow: [
          {
            required: true,
            message: "请选择审批流",
            trigger: "change",
            type: "number"
          }
        ],
        exceptionEndDate: [
          {
            required: true,
            message: "请选择例外结束日期",
            trigger: "blur",
            type: "date"
          }
        ],
        exception: [
          { required: true, message: "请选择是否例外", trigger: "change" }
        ],
        isWorkDay: [
          { required: true, message: "请选择是否工作日", trigger: "change" }
        ],
        describe: [
          { required: true, message: "请输入申请原因", trigger: "blur" },
          {
            type: "string",
            max: 100,
            message: "最多输入100个字符",
            trigger: "blur"
          }
        ]
      },
      columnInstance: [
        {
          title: this.$t("schedule_instance_config.ip"),
          key: "privateIp"
        },
        {
          title: this.$t("schedule_instance_config.instanceName"),
          key: "name"
        }
      ],
      columns1: [
        {
          field: "privateIp",
          title: "IP",
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "name",
          title: this.$t("schedule_instance_config.instanceName"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "awsResourceType",
          title: this.$t("schedule_instance_config.AWSType"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "instanceStatus",
          title: this.$t("schedule_instance_config.instanceStatus"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "action",
          title: this.$t("common.operation"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          componentName: "table-operation"
        }
      ],
      columns4: [
        {
          title: this.$t("schedule_instance_config.ip"),
          key: "privateIp"
        },
        {
          title: this.$t("schedule_instance_config.instanceName"),
          key: "name"
        },
        {
          title: this.$t("schedule_instance_config.instanceStatus"),
          key: "state"
        }
      ],
      startTimeOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      endTimeOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      editStartTimeOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      editEndTimeOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      serverSearchsDate: [],
      InstancesData: [],
      insertIPList: [],
      InstancesEditData: [],
      insertIPLists: []
    };
  },
  beforeCreate: function() {
    tableServerSearchs = this;
  },
  methods: {
    // 审批流
    selectListNames: function() {
      this.$api.processTemplate
        .selectListNames({
          type: 2,
          companyId: tableServerSearchs.companyId
        })
        .then(res => {
          this.approvalFlowList = res.data;
        });
    },
    //查询执行类型
    queryPerformType: function() {
      this.$api.schedule.queryPerformType().then(res => {
        this.performTypeList = res.data;
      });
    },
    //切换类型
    changePerformType: function() {
      if (
        this.timerSwitchForm.performType == 2 &&
        this.timerSwitchForm.exception == "true"
      ) {
        if (
          this.timerSwitchForm.exceptionStartTime == "" ||
          this.timerSwitchForm.exceptionStartTime == undefined
        ) {
          this.timerSwitchForm.exceptionStartTime = "00:00:00";
        }
      }
      if (
        this.timerSwitchForm.performType == 1 &&
        this.timerSwitchForm.exception == "true"
      ) {
        if (
          this.timerSwitchForm.exceptionEndTime == "" ||
          this.timerSwitchForm.exceptionEndTime == undefined
        ) {
          this.timerSwitchForm.exceptionEndTime = "00:00:00";
        }
      }
      if (this.timerSwitchForm.performType == 1) {
        if (
          this.timerSwitchForm.scheduleEndTime == "" ||
          this.timerSwitchForm.scheduleEndTime == undefined
        ) {
          this.timerSwitchForm.scheduleEndTime = "00:00:00";
        }
      }
      if (this.timerSwitchForm.performType == 2) {
        if (
          this.timerSwitchForm.scheduleStartTime == "" ||
          this.timerSwitchForm.scheduleStartTime == undefined
        ) {
          this.timerSwitchForm.scheduleStartTime = "00:00:00";
        }
      }
    },
    // 显示数据
    /**************************************************************/
    showAll: function(privateIp, single, awsResourceType, companyId) {
      tableServerSearchs.val = single;
      tableServerSearchs.privateIp = privateIp;
      tableServerSearchs.awsResourceType = awsResourceType;
      tableServerSearchs.companyId = companyId;
      tableServerSearchs.getServerSearchsData();
    },
    showTableServerSearchs: function() {
      for (var i = 0; i < this.serverSearchsDate.length; i++) {
        if (
          this.serverSearchsDate[i].scheduleStartTime == undefined ||
          this.serverSearchsDate[i].scheduleEndTime == undefined
        ) {
          this.serverSearchsDate[i].scheduleStartTime = "---";
          this.serverSearchsDate[i].scheduleEndTime = "---";
        }
        // 是否例外
        if (this.serverSearchsDate[i].isException == true) {
          this.serverSearchsDate[i].isException = this.$t("common.yes");
          // 例外开始时间
          this.serverSearchsDate[
            i
          ].exceptionStartDate = utils.methods.formatDate(
            this.serverSearchsDate[i].exceptionStartDate
          );
          // 例外结束时间
          this.serverSearchsDate[i].exceptionEndDate = utils.methods.formatDate(
            this.serverSearchsDate[i].exceptionEndDate
          );
        } else if (this.serverSearchsDate[i].isException == false) {
          this.serverSearchsDate[i].isException = this.$t("common.no");
          // 不是例外 那么例外开始、结束、开机、关机都为---
          this.serverSearchsDate[i].exceptionStartDate = "---";
          this.serverSearchsDate[i].exceptionEndDate = "---";
          this.serverSearchsDate[i].exceptionStartTime = "---";
          this.serverSearchsDate[i].exceptionEndTime = "---";
        }
        //实例状态
        this.serverSearchsDate[i].instanceStatus = this.statusList[
          this.serverSearchsDate[i].state
        ];

        //是否工作日
        if (this.serverSearchsDate[i].isWorkdays) {
          this.serverSearchsDate[i].isWorkDay = this.$t("common.yes");
        } else {
          this.serverSearchsDate[i].isWorkDay = this.$t("common.no");
        }

        // 状态
        if (this.serverSearchsDate[i].status == 0) {
          this.serverSearchsDate[i].status = this.$t(
            "schedule_instance_config.start"
          );
        } else if (this.serverSearchsDate[i].status == 1) {
          this.serverSearchsDate[i].status = this.$t(
            "schedule_instance_config.pause"
          );
        } else if (this.serverSearchsDate[i].status == 2) {
          this.serverSearchsDate[i].status = this.$t(
            "schedule_instance_config.close"
          );
        } else if (this.serverSearchsDate[i].status == 3) {
          this.serverSearchsDate[i].status = this.$t(
            "schedule_instance_config.exception"
          );
        }

        // aws资源类型
        if (this.serverSearchsDate[i].awsResourceType == 0) {
          this.serverSearchsDate[i].awsResourceType = this.$t(
            "schedule_instance_config.virtualHost"
          );
        } else if (this.serverSearchsDate[i].awsResourceType == 7) {
          this.serverSearchsDate[i].awsResourceType = this.$t(
            "schedule_instance_config.virtualDesktop"
          );
        }
      }
    },
    // 根据私有IP查询实例和定时任务
    getServerSearchsData: function() {
      this.modal_loading = true;
      // 根据私有IP查询实例和定时任务
      tableServerSearchs.$api.instance
        .queryAWSInstancesByPrivateIP({
          pageNum: this.current,
          hasTask: tableServerSearchs.val,
          maxResult: this.pageSize,
          privateIp: tableServerSearchs.privateIp,
          companyId: tableServerSearchs.companyId,
          awsResourceType: tableServerSearchs.awsResourceType
        })
        .then(res => {
          this.reachBottomParam = res.data;
          if (res.data.records) {
            this.exportDataList = JSON.parse(JSON.stringify(res.data));
            this.serverSearchsDate = JSON.parse(
              JSON.stringify(res.data.records)
            );
          }
          tableServerSearchs.showTableServerSearchs();
          this.modal_loading = false;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(err => {
          if (err.status == 404) {
            this.modal_loading = false;
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableServerSearchs.getServerSearchsData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableServerSearchs.getServerSearchsData();
    },
    // 创建
    /**************************************************************/
    // 传递vue组件
    customCompFuncAddTask(params) {
      this.lineIndex = params.index;
      this.rowData = params.rowData;
      this.$api.schedule
        .checkSchedule({
          instanceId: this.rowData.instanceId
        })
        .then(res => {
          setTimeout(() => {
            this.addLoading = false;
            this.$nextTick(() => {
              this.addLoading = true;
            });
            if (res.data > 0) {
              this.remindThereAreScheduledTasksModel = true;
            } else {
              this.addTask();
            }
          }, 1000);
        });
    },
    getState: function(stateStr) {
      for (var i = 0; i < this.statusList.length; i++) {
        if (stateStr == this.statusList[i]) {
          return i;
        }
      }
      return -1;
    },
    addTaskCancel: function() {
      this.remindThereAreScheduledTasksModel = false;
    },
    addTask: function() {
      this.remindThereAreScheduledTasksModel = false;
      this.insertIPList = [];
      this.insertIPLists = [];
      this.selectListNames();
      this.queryPerformType();
      // 添加定时任务
      var instanceStatus = this.getState(this.rowData.instanceStatus); //running

      this.addTimerSwitchModal = true;

      // 显示界面用
      var InsertIPListCopy = new Object();
      InsertIPListCopy.name = this.rowData.name;
      InsertIPListCopy.instanceId = this.rowData.instanceId;
      InsertIPListCopy.privateIp = this.rowData.privateIp;
      InsertIPListCopy.region = this.rowData.region;
      InsertIPListCopy.state = this.rowData.instanceStatus;
      InsertIPListCopy.accountId = this.rowData.accountId;
      this.insertIPLists.push(InsertIPListCopy);
      this.InstancesData = this.insertIPList;

      // 传接口用
      var InsertIPListCopy = new Object();
      InsertIPListCopy.name = this.rowData.name;
      InsertIPListCopy.instanceId = this.rowData.instanceId;
      InsertIPListCopy.privateIp = this.rowData.privateIp;
      InsertIPListCopy.region = this.rowData.region;
      InsertIPListCopy.state = instanceStatus;
      InsertIPListCopy.accountId = this.rowData.accountId;
      this.insertIPList.push(InsertIPListCopy);
      this.InstancesData = this.insertIPLists;
    },
    // 添加定时任务
    /**************************************************************/
    timerSwitchSubmit: function(name) {
      this.$refs[name].validate(valid => {
        // 如果是例外 开机时间、关机时间必填项
        if (valid) {
          // 创建定时任务
          this.$api.schedule
            .createSchedule({
              status: 0,
              isException: this.timerSwitchForm.exception,
              isWorkdays: this.timerSwitchForm.isWorkDay,
              exceptionStartTime: this.timerSwitchForm.exceptionStartTime,
              exceptionEndTime: this.timerSwitchForm.exceptionEndTime,
              exceptionStartDate: this.timerSwitchForm.exceptionStartDate,
              exceptionEndDate: this.timerSwitchForm.exceptionEndDate,
              scheduleStartTime: this.timerSwitchForm.scheduleStartTime,
              scheduleEndTime: this.timerSwitchForm.scheduleEndTime,
              description: this.timerSwitchForm.describe,
              instanceDTOS: this.insertIPList,
              processTemplateId: this.timerSwitchForm.approvalFlow,
              performType: this.timerSwitchForm.performType
            })
            .then(res => {
              setTimeout(() => {
                this.$refs[name].resetFields();
                this.addLoading = false;
                this.$nextTick(() => {
                  this.addLoading = true;
                });
                this.$Message.success("添加成功");
                tableServerSearchs.getServerSearchsData();
                this.insertIPList = [];
                this.insertIPLists = [];
                this.isDisabled = true;
                this.addTimerSwitchModal = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.addLoading = false;
          setTimeout(() => {
            this.addLoading = true;
          }, 0);
          this.$Message.error("添加失败");
        }
      });
    },
    timerSwitchReset: function(name) {
      this.$refs[name].resetFields();
    }
  }
};

// 定时开关机创建组件  如果当前行有id显示按钮
Vue.component("table-operation", {
  template: `
      <Button @click.stop.prevent="createTaskClick"
              v-hasPermission="['timerSwitchs:serverSearchs:add']"
              style="color: #fff;background-color: #2db7f5;border-color: #2db7f5;cursor: pointer;padding: 1px 7px 2px;font-size: 12px;border-radius: 3px;height: 23px;border: none;line-height: 23px;outline: none;"
              >{{$t('schedule_instance_config.add')}}
      </Button>`,
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  methods: {
    createTaskClick() {
      // 创建
      let params = { type: "create", index: this.index, rowData: this.rowData };
      this.$emit("on-custom-comp", params);
    }
  }
});
</script>



// WEBPACK FOOTER //
// src/components/timer_switchs/server_searchs/TableServerSearchs.vue